var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.7 0H7.3C3.285 0 0.0365 3.285 0.0365 7.3L0 73L14.6 58.4H65.7C69.715 58.4 73 55.115 73 51.1V7.3C73 3.285 69.715 0 65.7 0ZM65.7 51.1H11.5705L9.417 53.2535L7.3 55.3705V7.3H65.7V51.1ZM32.85 36.5H40.15V43.8H32.85V36.5ZM32.85 14.6H40.15V29.2H32.85V14.6Z",
    fill: "#00A15C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackIcon);
export default __webpack_public_path__ + "static/media/feedbackIcon.d96af50043de74c1e415267dd5392202.svg";
export { ForwardRef as ReactComponent };